import UserService from '../../services/user.service';
import ApiService from '../../services/api.service';
import asyncWrapper from '../../utils/asyncWrapper';
import {
  SET_LOGGED_IN,
  SET_LOGGED_OUT,
  SET_COGNITO_INFO,
  SNACKBAR,
  ERROR_SNACKBAR,
  SET_CREDENTIALS,
  SET_NEEDS_VERIFICATION,
  CLEAR_CREDENTIALS,
  SET_VERIFIED,
  SET_AUTH_ERRORS,
  SET_USERS,
  SET_SUB,
  SET_USER_EMAIL_ADDRESS,
  SET_USER_GROUPS
} from '../mutation-types';
import TokenService from '../../services/storage.service';

const state = {
  cognitoInfo: {},
  loggedIn: false,
  credentials: {
    username: '',
    password: ''
  },
  verified: true,
  authErrors: {
    isError: false,
    errorMessage: ''
  },
  users: [],
  sub: '',
  emailAddress: '',
  userGroups: []
}

const getters = {
  cognitoInfo: state => state.cognitoInfo,
  loggedIn: state => state.loggedIn,
  credentials: state => state.credentials,
  verified: state => state.verified,
  authErrors: state => state.authErrors,
  users: state => state.users,
  sub: state => state.sub,
  emailAddress: state => state.emailAddress,
  userGroups: state => state.userGroups
}

const actions = {
  async signup({ commit }, data) {
    commit(SET_CREDENTIALS, data);
    commit(SET_VERIFIED, false);
    const { error, result } = await asyncWrapper(UserService.signup(data));

    if(!error)
      commit(SET_COGNITO_INFO, result);
    else {
      commit(SET_COGNITO_INFO, {});
      commit(SET_AUTH_ERRORS, error);
    }
  },
  async verify({ commit, dispatch }, data) {
    commit(SET_VERIFIED, false);
    const { error } = await asyncWrapper(UserService.verify(data));

    if (!error) {
      commit(SET_LOGGED_IN);
      commit(CLEAR_CREDENTIALS);
      commit(SET_VERIFIED, null);
      dispatch('getUserEmailAddress');
    } else {
      commit(SET_AUTH_ERRORS, error.message);
    }
  },
  async signin({ commit, dispatch }, data) {
    commit(SET_CREDENTIALS, data);
    commit(SET_VERIFIED, true);
    const { error, result } = await asyncWrapper(UserService.signin(data));

    if (!error) {
      dispatch('getUserEmailAddress')
      commit(SET_LOGGED_IN);
      commit(CLEAR_CREDENTIALS);
      commit(SET_USER_GROUPS, result.groups)
    } else {
      commit(SET_AUTH_ERRORS, error.message)
      if (error.code === "UserNotConfirmedException") {
        commit(SET_VERIFIED, false);
        return;
      }
    }
  },
  async checkIfAuthenticated({ commit }) {
    const { error, result } = await asyncWrapper(UserService.checkIfAuthenticated());

    if (!error) {
      commit(SET_LOGGED_IN)
      commit(SET_USER_GROUPS, result.groups)
    }

    return { error }
  },
  async signout({ commit }) {
    const { error } = await asyncWrapper(UserService.signOut());

    if (!error) {
      commit(SET_LOGGED_OUT)
      commit(SET_USER_EMAIL_ADDRESS)
      commit(SET_USER_GROUPS, [])
    } else {
      commit(ERROR_SNACKBAR, error.message)
    }

    return { error }
  },
  async resendConfirmationCode({ commit }, username) {
    const { error, result } = await asyncWrapper(UserService.resendConfirmationCode(username));

    !error ? commit(SNACKBAR, 'New verification code was sent!') : commit(ERROR_SNACKBAR, error.message);
  },
  async getUsers({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('users'));

    !error ? commit(SET_USERS, result) : commit(ERROR_SNACKBAR, error.message);
  },
  getUserSub({ commit }) {
    commit(SET_SUB, TokenService.getToken('sub'));
  },
  async getUserEmailAddress({ commit }) {
    const email = await UserService.getUserEmailAddress()

    commit(SET_USER_EMAIL_ADDRESS, email);
  },
  async forgotPassword({ commit }, data) {
    const { error, result } = await asyncWrapper(UserService.forgotPassword(data))
    if (!error) {
      commit(SET_USER_EMAIL_ADDRESS, data);
      return true;
    }
    else {
      commit(ERROR_SNACKBAR, "Error during resetting password");
      return false;
    }
  },
  async forgotPasswordSubmit({ commit }, data) {
    const { result, error } = await asyncWrapper(UserService.forgotPasswordSubmit(data));
    commit(SET_USER_EMAIL_ADDRESS, '');
    if (!error)
      commit(SNACKBAR, "Password successfully changed");
    else
      commit(ERROR_SNACKBAR, "Error during resetting password");
  }
}

const mutations = {
  [SET_COGNITO_INFO](state, payload) {
    state.cognitoInfo = payload;
  },
  [SET_LOGGED_IN](state) {
    state.loggedIn = true;
  },
  [SET_LOGGED_OUT](state) {
    state.loggedIn = false
  },
  [SET_CREDENTIALS](state, payload) {
    state.credentials = payload;
  },
  // [SET_NEEDS_VERIFICATION] (state) {
  //   state.verified = true;
  // },
  [SET_VERIFIED](state, payload) {
    state.verified = payload;
  },
  [CLEAR_CREDENTIALS](state) {
    state.credentials = {};
  },
  [SET_AUTH_ERRORS](state, payload) {
    state.authErrors.isError = true;

    if (payload.code === 'InvalidPasswordException') {
      state.authErrors.errorMessage = 'Password is invalid';
    } else if (payload.code === 'UsernameExistsException') {
      state.authErrors.errorMessage = 'Account with this email already exists'
    } else if (payload.code === 'UserLambdaValidationException') {
      state.authErrors.errorMessage = 'You do not have access to this application'
    } else if (payload.message === "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128") {
      state.authErrors.errorMessage = 'Email must have length less than or equal to 128'
    } else {
      state.authErrors.errorMessage = payload;
    }
  },
  [SET_USERS](state, payload) {
    state.users = payload;
  },
  [SET_SUB](state, payload) {
    state.sub = payload;
  },
  [SET_USER_EMAIL_ADDRESS](state, payload) {
    state.emailAddress = payload
  },
  [SET_USER_GROUPS](state, payload) {
    state.userGroups = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

